import React from 'react'
import styled, { css } from 'styled-components'
import { StyledIconBase } from '@styled-icons/styled-icon'
import { FacebookSquare } from '@styled-icons/boxicons-logos/FacebookSquare'
import { LinkedinSquare } from '@styled-icons/boxicons-logos/LinkedinSquare'
import { forMediumScreenUp } from '../utils/style'

const Wrapper = styled.footer`
  margin-top: var(--spacing-4);
  padding: var(--spacing-8);
  background: #31424e;
  color: #fff;
  font-size: var(--fontSize-0);
`
const Inner = styled.div`
  ${forMediumScreenUp(css`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: var(--spacing-8);
  `)}
  max-width: var(--layout-width);
  margin: auto;
`
const Column = styled.div``
const Title = styled.h3`
  color: #fff;
  margin-top: var(--spacing-8);
  margin-bottom: var(--spacing-4);
  font-size: var(--fontSize-1);
`
const List = styled.ul`
  list-style-type: none;
  margin: var(--spacing-4) 0;
`
const ListItem = styled.li`
  margin-bottom: var(--spacing-2);
  ${StyledIconBase} {
    width: 2rem;
  }
`
const Link = styled.a`
  color: #fff;
  text-decoration: none;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`
const Copyright = styled.div`
  grid-column: 1/4;
  text-align: center;
  opacity: 0.7;
`

export const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <Wrapper>
      <Inner>
        <Column>
          <Title>Who are we?</Title>
          <div>
            A company full of teamwork and developing collaborative software to
            build teamwork for society.
          </div>
        </Column>

        <Column>
          <Title>Cybozu Vietnam</Title>
          <List>
            <ListItem>
              <Link href="https://www.cybozu.vn/">Homepage</Link>
            </ListItem>
            <ListItem>
              <Link href="https://www.cybozu.vn/about-us/">About Us</Link>
            </ListItem>
            <ListItem>
              <Link href="https://www.cybozu.vn/career-opportunities/">
                Career Opportunities
              </Link>
            </ListItem>
            <ListItem>
              <Link href="https://tech.cybozu.vn/">Tech Sharing</Link>
            </ListItem>
          </List>
        </Column>

        <Column>
          <Title>Cybozu Links</Title>
          <List>
            <ListItem>
              <Link href="https://cybozu-global.com/">Cybozu Global</Link>
            </ListItem>
            <ListItem>
              <Link href="https://tech.cybozu.io/">Cybozu Tech</Link>
            </ListItem>
            <ListItem>
              <Link href="https://tech.cybozu.io/oss/">
                Cybozu Open Source Software
              </Link>
            </ListItem>
          </List>
          <Title>Follow Us</Title>
          <List>
            <ListItem>
              <Link
                href="https://www.facebook.com/CybozuVietNam/"
                title="Cybozu Vietnam on Facebook"
              >
                <FacebookSquare />
              </Link>
              <Link
                href="https://www.linkedin.com/company/cybozu-vietnam/about/"
                title="Cybozu Vietnam on Linkedin"
              >
                <LinkedinSquare />
              </Link>
            </ListItem>
          </List>
        </Column>

        <Copyright>
          Copyright &#169; {year} Cybozu Vietnam Co., Ltd. All Rights Reserved
        </Copyright>
      </Inner>
    </Wrapper>
  )
}
